import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function about() {
    gsap.to('.js_scale', {
        scale: 1.3,
        scrollTrigger: {
            trigger: '.p-about-head__image',
            start: 'top 50%',
            end: 'bottom 30%',
            scrub: 1,
            ease: 'power1.inOut',
            duration: 1.3,
        },
    });
}
